
import { useState, useEffect } from 'react';
import { Session } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/components/ui/use-toast';
import { useNavigate } from 'react-router-dom';

export function useSessionManagement() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Setting up session management...");
    
    // Set up the auth state change listener first
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, newSession) => {
      console.log("Auth state change event:", event);
      console.log("New session:", newSession ? "Session present" : "No session");
      
      setSession(newSession);
      
      if (event === 'SIGNED_OUT') {
        navigate("/");
        toast({
          title: "Signed out",
          description: "You have been signed out successfully.",
        });
      } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        console.log("User signed in or token refreshed");
        if (window.location.pathname === '/auth' || window.location.pathname === '/login') {
          // Check for redirect parameter
          const urlParams = new URLSearchParams(window.location.search);
          const redirectUrl = urlParams.get('redirect');
          
          if (redirectUrl) {
            navigate(redirectUrl);
          } else {
            navigate("/dashboard");
          }
          
          toast({
            title: "Signed in",
            description: "Welcome back!",
          });
        }
      }
    });

    // Then check for an existing session
    const checkSession = async () => {
      try {
        console.log("Checking for existing session...");
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Error checking session:", error);
        } else {
          console.log("Current session data:", data);
          setSession(data.session);
        }
      } catch (error) {
        console.error("Error checking session:", error);
      } finally {
        setLoading(false);
      }
    };
    
    checkSession();

    return () => {
      console.log("Cleaning up session management...");
      subscription.unsubscribe();
    };
  }, [navigate, toast]);

  return { session, loading };
}
